<template lang="html">
  <img class="pt-3 mb-4" src="@/assets/logo.svg" alt="logo" width="250" />
  <div class="container-fluid">
    <h1 class="title mb-3">
      What score do you give the TOPdesk Town Summer Party 2026
    </h1>
    <div class="d-grid gap-2">
      <select
        v-model="checkedAnswer"
        class="form-select form-select-lg rounded-pill field"
      >
        <option disabled value="">Select a score</option>
        <option v-for="answer in answers" v-bind:key="answer" :value="answer">
          {{ answer }}
        </option>
      </select>

      <button
        type="button"
        class="btn btn-primary btn-lg rounded-pill"
        @click="setQuestionOne()"
        :disabled="!isValidAnswer"
      >
        <span>Next</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionOneScreen",
  data: () => ({
    answers: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "N/A"],
    checkedAnswer: "",
  }),
  methods: {
    setQuestionOne() {
      this.$store.commit("setQuestionOne", this.checkedAnswer);
    },
  },
  computed: {
    isValidAnswer() {
      return this.checkedAnswer !== "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";

h1 {
  font-family: $font-family-serif;
  font-size: 30px;
  color: $text-color;
}
.unselected {
  border: none !important;
  /* border-color: #000744 !important; */
}

.field {
  margin-bottom: 10px !important;
  outline: none;
  padding: 10px;
  font-size: 1.25rem;
  margin-bottom: 20px;
  background-color: #fff;
  width: 100% !important;
  box-sizing: border-box;
}
</style>
